import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Landing } from './pages/Landing';

/**
 * Landing loads eagerly (it is the LCP route); every sub-page is split out so
 * the first paint does not carry the calculator, the tour, or the FAQ set.
 */
const Solutions = lazy(() => import('./pages/Solutions'));
const UserRoles = lazy(() => import('./pages/UserRoles'));
const ProductTour = lazy(() => import('./pages/ProductTour'));
const Industries = lazy(() => import('./pages/Industries'));
const BenefitsCalculator = lazy(() => import('./pages/BenefitsCalculator'));
const Faqs = lazy(() => import('./pages/Faqs'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));

// A dev-only route for eyeballing every primitive against the comps.
const Kitchen = lazy(() => import('./pages/Kitchen'));

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<div style={{ minHeight: '60vh' }} />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/user-roles" element={<UserRoles />} />
            <Route path="/product-tour" element={<ProductTour />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/benefits-calculator" element={<BenefitsCalculator />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/contact" element={<Contact />} />
            {process.env.NODE_ENV === 'development' && (
              <Route path="/_ui" element={<Kitchen />} />
            )}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}
